import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// 禁用所有控制台输出
console.log = () => {};
console.error = () => {};
console.warn = () => {};
console.info = () => {};
console.debug = () => {};
console.trace = () => {};
console.table = () => {};
console.group = () => {};
console.groupEnd = () => {};
console.groupCollapsed = () => {};
console.time = () => {};
console.timeEnd = () => {};
console.timeLog = () => {};
console.count = () => {};
console.countReset = () => {};
console.clear = () => {};
console.dir = () => {};
console.dirxml = () => {};
console.assert = () => {};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
